import React from 'react';
import NumberFormat from 'react-number-format';



export default class ZaangazowaniePrint extends React.Component {


sumaall = (data, key) => {
  let total = 0;
  data.forEach((item, idx) => {
    let itemdot = item[key].replace(',', '.');
    let itemnum = parseFloat(itemdot);
    total += itemnum;
    total = parseFloat(total.toFixed(2));
  });
  return total;
};


render() {

const { data, nazwauchwaly } = this.props;

return (<React.Fragment>
<div class="d-flex justify-content-center w-100">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col" class="text-center" width="5%" >Dział</th>
        <th scope="col" class="text-center" width="5%" >Rozdział</th>
        <th scope="col" class="text-center" width="5%" >Paragraf</th>
        <th scope="col" class="text-center" width="5%" >Pozycja</th>
        <th scope="col" class="text-center" width="5%" >Rodzaj</th>
        <th scope="col" class="text-center" width="5%" >Komórka</th>
        <th scope="col" class="text-center" width="30%">Wyszczególnienie</th>
        <th scope="col" class="text-center" width="5%" >Plan</th>
        <th scope="col" class="text-center" width="5%" >Zaangażowanie</th>
        <th scope="col" class="text-center" width="5%" >Wydatki</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((dane, idx) => {
        const { dzial, rozdzial, paragrafP4, pozycja, dokwzp, komorka, nazwapar, kwota, zaangazowanie, wydatki } = dane;
        return (<tr key={idx}>
          <td>{dzial}</td>
          <td>{rozdzial}</td>
          <td>{paragrafP4}</td>
          <td>{pozycja}</td>
          <td>{dokwzp}</td>
          <td>{komorka}</td>
          <td>{nazwapar}</td>
          <td class="text-right"><NumberFormat value={kwota} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
          <td class="text-right"><NumberFormat value={zaangazowanie} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
          <td class="text-right"><NumberFormat value={wydatki} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
        </tr>)}
      )}
    </tbody>
  </table>
</div>
</React.Fragment>);

}

}

